import { render, staticRenderFns } from "./OwnersTransactionsAceptanceDetail.vue?vue&type=template&id=764f5e74&scoped=true&"
import script from "./OwnersTransactionsAceptanceDetail.vue?vue&type=script&lang=js&"
export * from "./OwnersTransactionsAceptanceDetail.vue?vue&type=script&lang=js&"
import style0 from "./OwnersTransactionsAceptanceDetail.vue?vue&type=style&index=0&id=764f5e74&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "764f5e74",
  null
  
)

export default component.exports